// extracted by mini-css-extract-plugin
export var fileUpload = "_df-1";
export var modalButton = "_df-0";